import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import SalesStaticTableCell from './SalesStaticTableCell';

const SalesStaticsTeamRow = ({ headerRows, data }) => {
  if (!headerRows || !data) {
    return null;
  }

  return (
    data &&
    data.map((hq, hIndex) => {
      return hq?.children?.map((dp, dpIndex) => {
        return (
          <TableRow key={dpIndex}>
            {dpIndex === 0 && dp.id !== 'total' && (
              <TableCell
                align="center"
                rowSpan={hq?.rowSpan}
                sx={{ width: 200 }}
              >
                {hq.name}
              </TableCell>
            )}
            <TableCell
              align="center"
              sx={{ width: 200 }}
              colSpan={dp.id === 'total' ? 2 : 1}
            >
              {dp.name}
            </TableCell>
            <SalesStaticTableCell data={dp} headerRows={headerRows} />
          </TableRow>
        );
      });
    })
  );
};

export default SalesStaticsTeamRow;
